import { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../components/Layout";

const Homepage = () => {
  const [creatures, setCreatures] = useState([]);
  const [gridLayout, setGridLayout] = useState({ cols: 0, rows: 0, total: 0 });
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    calculateGrid();
    window.addEventListener('resize', calculateGrid);
    return () => window.removeEventListener('resize', calculateGrid);
  }, []);

  const calculateGrid = () => {
    // Calculate available space (excluding sidebar)
    const sidebarWidth = 300;
    const availableWidth = window.innerWidth - sidebarWidth;
    const availableHeight = window.innerHeight;

    const boxSize = 400;

    // Calculate how many boxes fit
    const cols = Math.floor(availableWidth / boxSize);
    const rows = Math.floor(availableHeight / boxSize);
    const total = cols * rows;

    setGridLayout({ cols, rows, total });

    // Fetch creatures if we haven't already or if the count changed
    if (total > 0) {
      fetchCreatures(total);
    }
  };

  const fetchCreatures = (count) => {
    axios
      .get("https://creatureparty.net/dashboard/wp-json/creatureparty/v1/creatures")
      .then((res) => {
        // Get random creatures up to the count we need
        const shuffled = [...res.data].sort(() => 0.5 - Math.random());
        const selected = shuffled.slice(0, count);
        setCreatures(selected);
        setIsLoaded(true);
      })
      .catch((err) => console.log(err));
  };

  return (
    <Layout>
      <section className="Homepage">
        <div
          className="Homepage__Grid"
          style={{
            gridTemplateColumns: `repeat(${gridLayout.cols}, 400px)`,
            gridTemplateRows: `repeat(${gridLayout.rows}, 400px)`
          }}
        >
          {creatures.map((creature, index) => (
            <a
              key={`creature-${creature.id}`}
              href={`/creatures/${creature.id}`}
              className={`Homepage__Creature ${isLoaded ? 'is-positioned' : ''}`}
            >
              <img
                src={creature.img.medium}
                alt={creature.name}
              />
              <div className="Homepage__CreatureName">{creature.name}</div>
            </a>
          ))}
        </div>
      </section>
    </Layout>
  );
};

export default Homepage;
